export const toURL = (s) => !s ? '' : s.toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/--+/g, '-') // Replace multiple — with single -
    .replace(/[^\w-]+/g, '') // Remove all non-word characters such as spaces or tabs
    .trim();



// WEBPACK FOOTER //
// ./src/web-frontend-core/base/Tool.js